import { type ContentModalSortFilter } from 'types/interfaces/IContentModalSortFilter'

export const CHART_TYPES = Object.freeze({
    overall_revenue: 'overall_revenue',
    subscriptions: 'subscriptions',
    rebills: 'rebills',
    premium_sales: 'premium_sales',
    message_unlocks: 'message_unlocks',
    streaming_tips: 'streaming_tips',
    content_tips: 'content_tips',
    referral_revenue: 'referral_revenue'
})

export type ChartType = (typeof CHART_TYPES)[keyof typeof CHART_TYPES]

export interface SalesAnalytics {
    dateFrom?: string
    dateTo?: string
    categoryId?: string
    chart?: ChartType
}

export type ReportFilter = 'all' | 'premium' | 'videos' | 'photos'
export type ReportTab = 'content' | 'messages' | 'subscription' | 'streams'

export interface ReportsAnalytics<TChart = ChartType> {
    tab: ReportTab
    filter?: ReportFilter
    chart?: TChart
    dateFrom?: string
    dateTo?: string
    categoryId?: string
}
export type ContentFilter = 'all_media' | 'photos' | 'videos'
export interface ContentAnalytics {
    filter?: ContentFilter
    categoryId?: string
    pageParam: number
    sort: ContentModalSortFilter
}

export interface AnalyticsContentFeedCard {
    id: string
    created_at: Date
    updated_at: Date
    photos: any[]
    photos_preview: any[]
    videos: Video[]
    videos_preview: Videospreview[]
    sounds: any[]
    locked: string
    content_count: number
    rank: number
    category: any[]
    purchase_impressions: number
    overall_revenue: number
    purchases: number
    tips: number
    purchases_count: number
    tips_count: number
    media_views: number
    impressions: number
    likes: number
    comments: number
    average_video_played: number
    media_views_impression_rate: number
    purchase_impression_rate: number
    purchase_view_rate: number
    price: number | null

}
interface Videospreview {
    id: string
    order?: any
    orientation: string
    preview: Preview
}

interface Preview {
    src: string
    type: string
}
interface Video {
    id: string
    url: string
    caption?: any
    order?: any
    locked: number
    preview: number
    active_thumb?: any
    thumb_type?: any
    orientation: string
    duration: number
    created_at: string
    type: string
    status?: any
    played: boolean
    encoded: Encoded
}
interface Encoded {
    '360p'?: any
    '480p'?: any
    '720p'?: any
    '1080p'?: any
}

export interface AnalyticsContentResponse {
    code: number
    data: AnalyticsContentFeedCard[]
    meta: any
}

export interface AnalyticsContentStoriesCard {
    id: number
    user_id: string
    user: User
    background_color?: any
    category: any[]
    image_src: string
    image_orientation: string
    video_src?: any
    video_orientation?: any
    sound?: any
    duration: number
    created_at: string
    schedule_date?: any
    text: Text
    poll?: any
    like_count: number
    media_views: number
    tips: number
    overall_revenue: number
}
interface Text {
    value?: any
    x?: any
    y?: any
}
interface User {
    id: string
    name: string
    email: string
    username: string
    is_model: boolean
    avatar: Avatar
    display_name: string
    isSubscribed: boolean
    isRestricted: boolean
    isBlocked: boolean
    friends: string
    follower_count: number
    friend_count: number
    role: Role[]
    result?: any
    statistics: Statistics
}
interface Statistics {
    name: string
    last_activity: string
    expiring?: any
    total_spent?: any
    join_date?: any
    upsell_conversion_ratio: number
}
interface Role {
    id: number
    name: string
    guard_name: string
    created_at: string
    updated_at: string
    pivot: Pivot
}
interface Pivot {
    model_type: string
    model_id: string
    role_id: number
}
interface Avatar {
    id: number
    url: string
    created_at: string
}

export interface AnalyticsContentStoriesResponse {
    code: number
    data: AnalyticsContentStoriesCard[]
    meta: any
}

export interface AnalyticsContentMessagesCard {
    id: string
    created_at: string
    updated_at: string
    message_delivered_at: string
    body: string
    price: number
    actual_sent: number
    purchased_quantity: number
    purchased_amount: number
    photos: any[]
    photos_preview: string[]
    videos: any[]
    videos_preview: string[]
    sounds: any[]
    video_count: number
    photo_count: number
    sound_count: number
    participant_count: number
    message_viewed_count: number
}
export interface AnalyticsContentMessagesResponse {
    code: number
    data: AnalyticsContentMessagesCard[]
    meta: any
}
